import React from "react";

export default function TabPicker({ options, activeOption, onChange }) {
  return (
    <div>
      <div className="sm:hidden">
        <select
          aria-label="Selected tab"
          className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 transition ease-in-out duration-150"
          value={activeOption}
          onChange={(e) => onChange(e.target.value)}
        >
          {Object.entries(options).map(([key, title]) => (
            <option key={key} value={key}>
              {title}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex">
            {Object.entries(options).map(([key, title]) => (
              <a
                key={`a-${key}`}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onChange(key);
                }}
                className={`${
                  key == activeOption
                    ? "border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300"
                } mr-8 whitespace-no-wrap py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none`}
              >
                {title}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
